import { httpClient } from "@/helpers/httpClient";
export default class embeddedTokenApi {
    resource = "/api/application/embeddedToken";
    async getEmbeddedToken(userId) {
        return await httpClient.get(`${this.resource}?username=${userId}`);
    }
}
